var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.2495C4.44384 17.2495 0.750244 13.5559 0.750244 8.99976C0.750244 4.4436 4.44384 0.75 9 0.75C13.5562 0.75 17.2498 4.4436 17.2498 8.99976C17.2498 13.5559 13.5562 17.2495 9 17.2495ZM9 15.7498C12.728 15.7498 15.75 12.7277 15.75 8.99976C15.75 5.27178 12.728 2.24976 9 2.24976C5.27202 2.24976 2.25 5.27178 2.25 8.99976C2.25 12.7277 5.27202 15.7498 9 15.7498ZM9 9.28596L11.5853 10.579C11.9559 10.7639 12.1064 11.2146 11.9207 11.5852C11.7358 11.9557 11.2851 12.1062 10.9146 11.9206L7.91433 10.4208C7.6605 10.2935 7.50019 10.0341 7.50019 9.75001V5.25002C7.50019 4.83587 7.83558 4.49978 8.24973 4.49978C8.66387 4.49978 8.99997 4.83587 8.99997 5.25002L9 9.28596Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.e35c07bc.svg";
export { ForwardRef as ReactComponent };